import Country from "../../components/country/Country"

function CountryPage() {
    return (
        <>
            <Country />
        </>
    )
}
export default CountryPage